<template>
  <div :id="$route.name">
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">افزودن ماژول سخت افزاری</h4>
        <hr />
      </template>
      <template v-slot:content>
        <form @submit.prevent="$ValidForm(this)" autocomplete="off">
          <div class="row">
            <div class="col-md-1 col-12">
              <small id="LblGrp7">محصول</small>
              <SearchableCombo :edit="false" :grp="7" :code="null" @ResultCombo="GetResulGrp7" :rownumintable="3" :defaultvalue="TblComboIdGrp7" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp7'" :keyItem="'Grp7'" :ClassProps="'required'"> </SearchableCombo>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblGrp8">نسخه</small>
              <SearchableCombo :edit="false" :grp="8" :code="null" @ResultCombo="GetResulGrp8" :rownumintable="3" :defaultvalue="TblComboIdGrp8" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp8'" :keyItem="'Grp8'" :ClassProps="'required'"> </SearchableCombo>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblLockCode">کد مشتری</small>
              <input type="text" class="form-control" dir="ltr" v-model="LockCode" disabled />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblBaje">تعداد باجه</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 2)" dir="ltr" v-model="Baje" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblUser">تعداد یوزر</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 3)" dir="ltr" v-model="User" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblUser">تعداد اعضا</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 15)" dir="ltr" v-model="Aza" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblSal">سال</small>
              <input type="text" class="form-control InputText required" @keypress="$ValidNumber($event, 4)" dir="ltr" v-model="Sal" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblMandeNet"> اینترنت بانک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="MandeNet" v-model="MandeNet" />
                <label class="custom-control-label mr-2" for="MandeNet"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblVariz">واریز</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Variz" v-model="Variz" />
                <label class="custom-control-label mr-2" for="Variz"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblGhore">قرعه کشی</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Ghore" v-model="Ghore" />
                <label class="custom-control-label mr-2" for="Ghore"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblPanelSms">پانل پیامک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="PanelSms" v-model="PanelSms" />
                <label class="custom-control-label mr-2" for="PanelSms"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblAsnadDar">اسناد دریافتنی</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="AsnadDar" v-model="AsnadDar" />
                <label class="custom-control-label mr-2" for="AsnadDar"> </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-1 col-12">
              <small id="LblSood">سود سپرده</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Sood" v-model="Sood" />
                <label class="custom-control-label mr-2" for="Sood"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblSmsbank">پیامک بانک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Smsbank" v-model="Smsbank" />
                <label class="custom-control-label mr-2" for="Smsbank"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTedadDb">DB</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 2)" dir="ltr" v-model="TedadDb" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTashilat">وام</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Tashilat" v-model="Tashilat" />
                <label class="custom-control-label mr-2" for="Tashilat"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblGardeshTashilat">گ وام</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="GardeshTashilat" v-model="GardeshTashilat" />
                <label class="custom-control-label mr-2" for="GardeshTashilat"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblOnlineUser">کاربر همزمان</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 2)" dir="ltr" v-model="OnlineUser" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTelBank">تلبانک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="TelBank" v-model="TelBank" />
                <label class="custom-control-label mr-2" for="TelBank"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblMobileBank">همبانک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="MobileBank" v-model="MobileBank" />
                <label class="custom-control-label mr-2" for="MobileBank"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTlgBank">تلگرام بانک</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="TlgBank" v-model="TlgBank" />
                <label class="custom-control-label mr-2" for="TlgBank"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblIsEtebar">اعتبارسنجی</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsEtebar" v-model="IsEtebar" />
                <label class="custom-control-label mr-2" for="IsEtebar"> </label>
              </div>
            </div>

            <div class="col-md-1 col-12">
              <small id="LblIsPos">پوز</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsPos" v-model="IsPos" />
                <label class="custom-control-label mr-2" for="IsPos"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblIsFinger">اثرانگشت</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsFinger" v-model="IsFinger" />
                <label class="custom-control-label mr-2" for="IsFinger"> </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-1 col-12">
              <small id="LblIsAni">آنی</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsAni" v-model="IsAni" />
                <label class="custom-control-label mr-2" for="IsAni"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblIsAtm">ATM</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsAtm" v-model="IsAtm" />
                <label class="custom-control-label mr-2" for="IsAtm"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblIsCard">کارت مستقل</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsCard" v-model="IsCard" />
                <label class="custom-control-label mr-2" for="IsCard"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblIsShetab">شتاب</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="IsShetab" v-model="IsShetab" />
                <label class="custom-control-label mr-2" for="IsShetab"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblOutUser">کاربر راه دور</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 3)" dir="ltr" v-model="OutUser" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblOutBaje">باجه راه دور</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 3)" dir="ltr" v-model="OutBaje" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblShobeCount">تعداد شعبه</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 3)" dir="ltr" v-model="ShobeCount" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTedadBajeMoshtari">تعداد باجه مشتری</small>
              <input type="number" class="form-control InputText required" @keypress="$ValidNumber($event, 2)" dir="ltr" v-model="TedadBajeMoshtari" />
            </div>
            <div class="col-md-1 col-12">
              <small id="LblSahmiyeBandiVaPardaxt">سهمیه بندی</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="SahmiyeBandiVaPardaxt" v-model="SahmiyeBandiVaPardaxt" />
                <label class="custom-control-label mr-2" for="SahmiyeBandiVaPardaxt"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblAmniyat">پکیج امنیت اطلاعات</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="Amniyat" v-model="Amniyat" />
                <label class="custom-control-label mr-2" for="Amniyat"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblTolidSheba">تولید کد شبا</small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="TolidSheba" v-model="TolidSheba" />
                <label class="custom-control-label mr-2" for="TolidSheba"> </label>
              </div>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblPayaVaSatna">پایا و ساتنا </small>
              <div class="custom-control custom-switch mt-2">
                <input type="checkbox" class="custom-control-input InputText" id="PayaVaSatna" v-model="PayaVaSatna" />
                <label class="custom-control-label mr-2" for="PayaVaSatna"> </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-4 col-12">
              <small> تاریخ آخرین ورود : </small>
              <date-picker color="dimgray" input-class="required form-control text-center" v-model="DateOfLastEntry" :editable="true" placeholder=" تاریخ آخرین ورود "></date-picker>
            </div>
            <div class="col-md-4 col-12">
              <small id="LblExpDate">تاریخ انقضای قفل</small>
              <date-picker color="dimgray" input-class="required form-control text-center" v-model="ExpDate" :editable="true" placeholder=" تاریخ انقضای قفل "></date-picker>
            </div>
            <div class="col-md-4 col-12">
              <small id="LblChargeAmount">مبلغ شارژ </small>
              <input type="text" class="form-control text-center InputText 3ragham required" @keyup="ChargeAmount = $PutCommatoInput_New($event);" @keypress="$ValidNumber($event, 11)" dir="ltr" v-model="ChargeAmount" />
            </div>
            <div class="col-md-6 col-12">
              <small id="LblChargeAmount"> اسم قفل </small>
              <input type="text" class="form-control InputText required" @keypress="$ValidPersian($event, 200)" dir="rtl" v-model="LockName" />
            </div>
            <div class="col-md-6 col-12">
              <small id="LblChargeAmount"> اسم زیرنویس </small>
              <input type="text" class="form-control InputText required" @keypress="$ValidPersian($event, 200)" dir="rtl" v-model="SubtitleName" />
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12 text-center">
              <button type="button" class="btn btn-primary" dir="ltr" title="برای کپی کد قفل کلیک کنید" @click="copyData()">
                <span class="badge" id="CodeModule">
                  {{ Sal }}.
                  <!-- 1176 Cash   -->
                  <!-- 1666 Offline   -->
                  {{ TblComboIdGrp7 == 1219 ? 1 : TblComboIdGrp7 == 1666 ? 1 : 'NF' }}. {{ LockCode }}. {{ Variz == true ? 2 : 1 }}. {{ Ghore == true ? 2 : 1 }}. {{ PanelSms == true ? 2 : 1 }}. {{ MandeNet == true ? 2 : 1 }}. {{ AsnadDar == true ? 2 : 1 }}. {{ Sood == true ? 2 : 1 }}.
                  <!-- 1179 شعبه ای  -->
                  <!-- 1178 سازمانی  -->
                  <!-- 1650 تعاونی اعتبار  -->
                  <!-- 1177 خانوادگی  -->
                  {{ TblComboIdGrp8 == 1179 ? 3 : TblComboIdGrp8 == 1178 ? 2 : TblComboIdGrp8 == 1650 ? 8 : TblComboIdGrp8 == 1177 ? 1 : 'NF' }}. {{ User }}. {{ Aza }}. {{ Baje }}. {{ Smsbank == true ? 2 : 1 }}. {{ TedadDb }}. {{ Tashilat == true ? 2 : 1 }}. {{ GardeshTashilat == true ? 2 : 1 }}.
                  {{ OnlineUser }}. {{ TelBank == true ? 2 : 1 }}. {{ MobileBank == true ? 2 : 1 }}. {{ TlgBank == true ? 2 : 1 }}. {{ IsEtebar == true ? 2 : 1 }}. {{ IsPos == true ? 2 : 1 }}. {{ IsFinger == true ? 2 : 1 }}. {{ IsAni == true ? 2 : 1 }}. {{ IsAtm == true ? 2 : 1 }}.
                  {{ IsCard == true ? 2 : 1 }}. {{ IsShetab == true ? 2 : 1 }}. {{ OutUser }}. {{ OutBaje }}. {{ ShobeCount }}. {{ TedadBajeMoshtari }}. {{ SahmiyeBandiVaPardaxt == true ? 2 : 1 }}. {{ Amniyat == true ? 2 : 1 }}. {{ TolidSheba == true ? 2 : 1 }}.
                  {{ PayaVaSatna == true ? 2 : 1 }}
                </span>
              </button>
            </div>
          </div>
        </form>
        <button v-if="$route.params.Status == 'Add'" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
        <button v-if="$route.params.Status == 'Edit'" class="btn btn-success mr-5" @click.prevent="SaveEditDeta()">ثبت تغییرات</button>
        <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  data() {
    return {
      DataAxiosPost: {
        ArryfildValue: {},
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAxios: {},
      TblCustomerId: 0,
      LockCode: 0,
      TblComboIdGrp7: 0,
      TblComboIdGrp8: 0,
      Baje: 1,
      User: 1,
      Aza: 1,
      Sal: '00',
      TedadDb: 1,
      OnlineUser: 1,
      ShobeCount: 1,
      TedadBajeMoshtari: 1,
      MandeNet: true,
      Variz: true,
      Ghore: true,
      PanelSms: true,
      AsnadDar: true,
      IsAni: true,
      IsFinger: true,
      IsPos: true,
      IsEtebar: true,
      MobileBank: true,
      TelBank: true,
      TlgBank: true,
      GardeshTashilat: true,
      Tashilat: true,
      Smsbank: true,
      Sood: true,
      IsAtm: true,
      IsCard: true,
      IsShetab: true,
      OutUser: 1,
      OutBaje: 1,
      SahmiyeBandiVaPardaxt: true,
      Amniyat: true,
      TolidSheba: true,
      PayaVaSatna: true,
      ExpDate: '',
      ChargeAmount: 100000,
      LockName: '',
      SubtitleName: '',
      DateOfLastEntry: '',
    }
  },
  components: { Card, SearchableCombo, datePicker: VuePersianDatetimePicker, BtnSaveData },
  props: ['CustomerId', 'CustCode','CustomerName'],
  methods: {
    GetResulGrp7(data) {
      this.TblComboIdGrp7 = data.id
    },
    GetResulGrp8(data) {
      this.TblComboIdGrp8 = data.id
    },
    Cancel() {
      this.returnToCustomer()
    },
    copyData() {
      var code = document.getElementById('CodeModule')
      navigator.clipboard.writeText(code.innerHTML.trim().replace(/ +/g, ''))
      this.$toasted.success(' کد قفل ' + ' کپی شد', {})
    },
    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
        this.DataAxiosPost.Action = 'Modules'
        this.DataAxiosPost.ArryfildValue.TblCustomerId = this.TblCustomerId
        this.DataAxiosPost.ArryfildValue.LockCode = this.LockCode
        this.DataAxiosPost.ArryfildValue.TblComboIdGrp7 = this.TblComboIdGrp7
        this.DataAxiosPost.ArryfildValue.TblComboIdGrp8 = this.TblComboIdGrp8
        this.DataAxiosPost.ArryfildValue.Baje = this.Baje
        this.DataAxiosPost.ArryfildValue.User = this.User
        this.DataAxiosPost.ArryfildValue.Aza = this.Aza
        this.DataAxiosPost.ArryfildValue.Sal = this.Sal
        this.DataAxiosPost.ArryfildValue.TedadDb = this.TedadDb
        this.DataAxiosPost.ArryfildValue.OnlineUser = this.OnlineUser
        this.DataAxiosPost.ArryfildValue.ShobeCount = this.ShobeCount
        this.DataAxiosPost.ArryfildValue.TedadBajeMoshtari = this.TedadBajeMoshtari
        this.DataAxiosPost.ArryfildValue.MandeNet = this.MandeNet
        this.DataAxiosPost.ArryfildValue.Variz = this.Variz
        this.DataAxiosPost.ArryfildValue.Ghore = this.Ghore
        this.DataAxiosPost.ArryfildValue.PanelSms = this.PanelSms
        this.DataAxiosPost.ArryfildValue.AsnadDar = this.AsnadDar
        this.DataAxiosPost.ArryfildValue.IsAni = this.IsAni
        this.DataAxiosPost.ArryfildValue.IsFinger = this.IsFinger
        this.DataAxiosPost.ArryfildValue.IsPos = this.IsPos
        this.DataAxiosPost.ArryfildValue.IsEtebar = this.IsEtebar
        this.DataAxiosPost.ArryfildValue.MobileBank = this.MobileBank
        this.DataAxiosPost.ArryfildValue.TelBank = this.TelBank
        this.DataAxiosPost.ArryfildValue.TlgBank = this.TlgBank
        this.DataAxiosPost.ArryfildValue.GardeshTashilat = this.GardeshTashilat
        this.DataAxiosPost.ArryfildValue.Tashilat = this.Tashilat
        this.DataAxiosPost.ArryfildValue.Smsbank = this.Smsbank
        this.DataAxiosPost.ArryfildValue.Sood = this.Sood
        this.DataAxiosPost.ArryfildValue.IsAtm = this.IsAtm
        this.DataAxiosPost.ArryfildValue.IsCard = this.IsCard
        this.DataAxiosPost.ArryfildValue.IsShetab = this.IsShetab
        this.DataAxiosPost.ArryfildValue.IsShetab = this.IsShetab
        this.DataAxiosPost.ArryfildValue.OutUser = this.OutUser
        this.DataAxiosPost.ArryfildValue.OutBaje = this.OutBaje
        this.DataAxiosPost.ArryfildValue.SahmiyeBandiVaPardaxt = this.SahmiyeBandiVaPardaxt
        this.DataAxiosPost.ArryfildValue.Amniyat = this.Amniyat
        this.DataAxiosPost.ArryfildValue.TolidSheba = this.TolidSheba
        this.DataAxiosPost.ArryfildValue.PayaVaSatna = this.PayaVaSatna
        this.DataAxiosPost.ArryfildValue.ExpDate = this.ExpDate
        this.DataAxiosPost.ArryfildValue.ChargeAmount = this.ChargeAmount.replace(/,/g, '').replace(/\./g, '')
        this.DataAxiosPost.ArryfildValue.LockName = this.LockName
        this.DataAxiosPost.ArryfildValue.SubtitleName = this.SubtitleName
        this.DataAxiosPost.ArryfildValue.DateOfLastEntry = this.DateOfLastEntry

        this.$PostData(this.DataAxiosPost).then((data) => {
          if (data.status == 'Ok') {
            this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')
          }
        })
      }
    },
    SaveEditDeta() {
      if (this.$ValidForm(this.$route.name)) {
        this.DataAxiosUpdate.Action = 'Modules'
        this.DataAxiosUpdate.ArryfildValue.TblCustomerId = this.TblCustomerId
        this.DataAxiosUpdate.ArryfildValue.LockCode = this.LockCode
        this.DataAxiosUpdate.ArryfildValue.TblComboIdGrp7 = this.TblComboIdGrp7
        this.DataAxiosUpdate.ArryfildValue.TblComboIdGrp8 = this.TblComboIdGrp8
        this.DataAxiosUpdate.ArryfildValue.Baje = this.Baje
        this.DataAxiosUpdate.ArryfildValue.User = this.User
        this.DataAxiosUpdate.ArryfildValue.Aza = this.Aza
        this.DataAxiosUpdate.ArryfildValue.Sal = this.Sal
        this.DataAxiosUpdate.ArryfildValue.TedadDb = this.TedadDb
        this.DataAxiosUpdate.ArryfildValue.OnlineUser = this.OnlineUser
        this.DataAxiosUpdate.ArryfildValue.ShobeCount = this.ShobeCount
        this.DataAxiosUpdate.ArryfildValue.TedadBajeMoshtari = this.TedadBajeMoshtari
        this.DataAxiosUpdate.ArryfildValue.MandeNet = this.MandeNet
        this.DataAxiosUpdate.ArryfildValue.Variz = this.Variz
        this.DataAxiosUpdate.ArryfildValue.Ghore = this.Ghore
        this.DataAxiosUpdate.ArryfildValue.PanelSms = this.PanelSms
        this.DataAxiosUpdate.ArryfildValue.AsnadDar = this.AsnadDar
        this.DataAxiosUpdate.ArryfildValue.IsAni = this.IsAni
        this.DataAxiosUpdate.ArryfildValue.IsFinger = this.IsFinger
        this.DataAxiosUpdate.ArryfildValue.IsPos = this.IsPos
        this.DataAxiosUpdate.ArryfildValue.IsEtebar = this.IsEtebar
        this.DataAxiosUpdate.ArryfildValue.MobileBank = this.MobileBank
        this.DataAxiosUpdate.ArryfildValue.TelBank = this.TelBank
        this.DataAxiosUpdate.ArryfildValue.TlgBank = this.TlgBank
        this.DataAxiosUpdate.ArryfildValue.GardeshTashilat = this.GardeshTashilat
        this.DataAxiosUpdate.ArryfildValue.Tashilat = this.Tashilat
        this.DataAxiosUpdate.ArryfildValue.Smsbank = this.Smsbank
        this.DataAxiosUpdate.ArryfildValue.Sood = this.Sood
        this.DataAxiosUpdate.ArryfildValue.IsAtm = this.IsAtm
        this.DataAxiosUpdate.ArryfildValue.IsCard = this.IsCard
        this.DataAxiosUpdate.ArryfildValue.IsShetab = this.IsShetab
        this.DataAxiosUpdate.ArryfildValue.IsShetab = this.IsShetab
        this.DataAxiosUpdate.ArryfildValue.OutUser = this.OutUser
        this.DataAxiosUpdate.ArryfildValue.OutBaje = this.OutBaje
        this.DataAxiosUpdate.ArryfildValue.SahmiyeBandiVaPardaxt = this.SahmiyeBandiVaPardaxt
        this.DataAxiosUpdate.ArryfildValue.Amniyat = this.Amniyat
        this.DataAxiosUpdate.ArryfildValue.TolidSheba = this.TolidSheba
        this.DataAxiosUpdate.ArryfildValue.PayaVaSatna = this.PayaVaSatna

        this.DataAxiosUpdate.ArryfildValue.ExpDate = this.ExpDate
        this.DataAxiosUpdate.ArryfildValue.ChargeAmount = Number(this.ChargeAmount.replace(/,/g, '').replace(/\./g, ''))
        this.DataAxiosUpdate.ArryfildValue.LockName = this.LockName
        this.DataAxiosUpdate.ArryfildValue.SubtitleName = this.SubtitleName
        this.DataAxiosUpdate.ArryfildValue.DateOfLastEntry = this.DateOfLastEntry

        // console.log(this.DataAxiosPost.ArryfildValue.ExpDate)
        // console.log(this.DataAxiosPost.ArryfildValue.ChargeAmount)
        // console.log(this.DataAxiosPost.ArryfildValue.LockName)
        // console.log(this.DataAxiosPost.ArryfildValue.SubtitleName)
        console.log(this.DataAxiosPost.ArryfildValue)

        this.$SetLog(this.DataAxiosUpdate.ArryfildValue, 0)
        this.$PutData_Body(this.DataAxiosUpdate).then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('اطلاعات با موفقیت تغییر یافت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.returnToCustomer()
          } else {
            if (data.eNum == '2601') {
              this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
            }
          }
        })
      }
    },
    returnToCustomer() {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.TblCustomerId, activeTab: 8 } })
      this.$FindeCustomerById('DetailCustomer',this.TblCustomerId,8,null)
    },
  },
  mounted() {
    if (this.$route.params.Status == 'Add') {
      this.DataAxiosPost.ArryfildValue.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxios = this.$route.params.DataRow

      this.LockCode = this.DataAxios.CustCode
      this.TblCustomerId = this.DataAxios.CustomerId
      this.TblComboIdGrp7 = this.DataAxios.TblComboIdGrp7
      this.TblComboIdGrp8 = this.DataAxios.TblComboIdGrp8
      this.Baje = this.DataAxios.Baje
      this.User = this.DataAxios.User
      this.Aza = this.DataAxios.Aza
      this.Sal = this.DataAxios.Sal
      this.TedadDb = this.DataAxios.TedadDB
      this.OnlineUser = this.DataAxios.OnlineUser
      ;(this.ShobeCount = this.DataAxios.ShobeCount), (this.TedadBajeMoshtari = this.DataAxios.TedadBajeMoshtari)
      this.MandeNet = this.DataAxios.MandeNet
      this.Variz = this.DataAxios.Variz
      ;(this.Ghore = this.DataAxios.Ghore), (this.PanelSms = this.DataAxios.PanelSMS)
      this.AsnadDar = this.DataAxios.AsnadDar
      this.IsAni = this.DataAxios.isAni
      this.IsFinger = this.DataAxios.isFinger
      this.IsPos = this.DataAxios.isPos
      this.IsEtebar = this.DataAxios.isEtebar
      this.MobileBank = this.DataAxios.MobileBank
      this.TelBank = this.DataAxios.TelBank
      this.TlgBank = this.DataAxios.TlgBank
      this.GardeshTashilat = this.DataAxios.GardeshTashilat
      this.Tashilat = this.DataAxios.Tashilat
      this.Smsbank = this.DataAxios.Smsbank
      this.Sood = this.DataAxios.Sood
      this.IsAtm = this.DataAxios.isAtm
      this.IsCard = this.DataAxios.isCard
      this.IsShetab = this.DataAxios.isShetab
      this.OutUser = this.DataAxios.OutUser
      this.OutBaje = this.DataAxios.OutBaje
      ;(this.SahmiyeBandiVaPardaxt = this.DataAxios.SahmiyeBandiVaPardaxt), (this.Amniyat = this.DataAxios.Amniyat)
      this.TolidSheba = this.DataAxios.TolidSheba
      this.PayaVaSatna = this.DataAxios.PayaVaSatna

      this.ExpDate = ''
      this.LockName = this.CustomerName?this.CustomerName:this.$route.params.DataRow.LockName
      this.SubtitleName = this.CustomerName?this.CustomerName:this.$route.params.DataRow.SubtitleName
      this.DateOfLastEntry = this.$GetJalaliDate()
      this.ChargeAmount = this.$Comma3ragham(100000)
    }
    if (this.$route.params.Status == 'Edit') {
      this.DataAxios = this.$route.params.DataRow
      this.LockCode = this.DataAxios.CustCode
      this.TblCustomerId = this.DataAxios.CustomerId
      this.TblComboIdGrp7 = this.DataAxios.TblComboIdGrp7
      this.TblComboIdGrp8 = this.DataAxios.TblComboIdGrp8
      this.Baje = this.DataAxios.Baje
      this.User = this.DataAxios.User
      this.Aza = this.DataAxios.Aza
      this.Sal = this.DataAxios.Sal
      this.TedadDb = this.DataAxios.TedadDB
      this.OnlineUser = this.DataAxios.OnlineUser
      ;(this.ShobeCount = this.DataAxios.ShobeCount), (this.TedadBajeMoshtari = this.DataAxios.TedadBajeMoshtari)
      this.MandeNet = this.DataAxios.MandeNet
      this.Variz = this.DataAxios.Variz
      ;(this.Ghore = this.DataAxios.Ghore), (this.PanelSms = this.DataAxios.PanelSMS)
      this.AsnadDar = this.DataAxios.AsnadDar
      this.IsAni = this.DataAxios.isAni
      this.IsFinger = this.DataAxios.isFinger
      this.IsPos = this.DataAxios.isPos
      this.IsEtebar = this.DataAxios.isEtebar
      this.MobileBank = this.DataAxios.MobileBank
      this.TelBank = this.DataAxios.TelBank
      this.TlgBank = this.DataAxios.TlgBank
      this.GardeshTashilat = this.DataAxios.GardeshTashilat
      this.Tashilat = this.DataAxios.Tashilat
      this.Smsbank = this.DataAxios.Smsbank
      this.Sood = this.DataAxios.Sood
      this.IsAtm = this.DataAxios.isAtm
      this.IsCard = this.DataAxios.isCard
      this.IsShetab = this.DataAxios.isShetab
      this.OutUser = this.DataAxios.OutUser
      this.OutBaje = this.DataAxios.OutBaje
      ;(this.SahmiyeBandiVaPardaxt = this.DataAxios.SahmiyeBandiVaPardaxt), (this.Amniyat = this.DataAxios.Amniyat)
      this.TolidSheba = this.DataAxios.TolidSheba
      this.PayaVaSatna = this.DataAxios.PayaVaSatna

      this.ExpDate = this.DataAxios.ExpDate
      this.LockName = this.DataAxios.LockName
      this.SubtitleName = this.DataAxios.SubtitleName == null ? '' : this.DataAxios.SubtitleName
      this.ChargeAmount = this.$Comma3ragham(this.DataAxios.ChargeAmount)
      this.DateOfLastEntry = this.DataAxios.DateOfLastEntry

      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
      this.DataAxiosUpdate.ArryfildValue.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxiosUpdate.ArryfildValue.TblUserGrpIdInsert = this.DataAxios.TblUserGrpIdInsert
      this.DataAxiosUpdate.ArryfildValue.Id = this.DataAxios.Id
      this.DataAxiosUpdate.ArryfildValue.DateTimeInsert = this.DataAxios.DateTimeInsert
    }
  },
}
</script>
<style scoped></style>
